import merge from 'lodash/merge';

export const unionWithMerge = (arr1, arr2, key) => {
  const map = new Map();

  [...arr1, ...arr2].forEach((obj) => {
    const existing = map.get(obj[key]);
    map.set(obj[key], existing ? merge(existing, obj) : obj);
  });

  return [...map.values()];
};

export const getLabelByValue = (fieldsConfig, fieldKey, value) => {
  const field = fieldsConfig.find((f) => f.key === fieldKey);

  if (!field || !field.enumOptions) {
    return null;
  }

  const matchedOption = field.enumOptions.find(
    (option) => option.option === value
  );

  return matchedOption ? matchedOption.label : null;
};
